import { useState, useCallback, useRef, useEffect } from 'react';
import { classify, classifyScoped } from '@barter/shared';
import type { ClassificationResult } from '@barter/shared';

// Классификация категории считается локально (словарный классификатор
// из @barter/shared) — серверный /api/classify больше не нужен.

/** classify() даёт раздел, classifyScoped() уточняет до группы запчастин. */
function classifyToGroup(text: string): ClassificationResult {
  const base = classify(text);
  if (
    base.categoryId === 'parts-cars' ||
    base.categoryId === 'parts-wheels' ||
    base.categoryId === 'parts-accessories'
  ) {
    return { ...base, categoryId: classifyScoped(text, base.categoryId) };
  }
  return base;
}

export function useClassifier(delay = 300) {
  const [result, setResult] = useState<ClassificationResult | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const classifyLocal = useCallback(
    (title: string, description?: string) => {
      if (timerRef.current) clearTimeout(timerRef.current);

      if (!title.trim()) {
        setResult(null);
        return;
      }

      timerRef.current = setTimeout(() => {
        try {
          setResult(classifyToGroup([title, description].filter(Boolean).join(' ')));
        } catch {
          setResult(null);
        }
      }, delay);
    },
    [delay],
  );

  const reset = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setResult(null);
  }, []);

  return { result, loading: false, classify: classifyLocal, reset };
}
